var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A1DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11H14a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V13a2 2 0 00-2-2z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11h10v1.63A1.37 1.37 0 0123.63 14h-7.26A1.37 1.37 0 0115 12.63V11zM19 18h6M15 18h1M19 21h6M15 21h1M19 24h6M15 24h1",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
export default SvgDocs;